<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-buttons slot="start">
          <ion-button @click="onCancel">Cancel</ion-button>
        </ion-buttons>
        <ion-title>Scan QRCode</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="switchCamera">
            <ion-icon ios="ios-camera" md="md-camera"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <qrcode-drop-zone @decode="onScan" @init="onError">
        <qrcode-stream @decode="onScan" @init="onInit"></qrcode-stream>
      </qrcode-drop-zone>
      <qrcode-capture v-if="noStreamApiSupport" @decode="onScan" />
    </ion-content>
  </div>
</template>

<script>
import Plugins from "../mixins/Plugins";
import Helpers from "../mixins/Helpers";
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from "vue-qrcode-reader";
export default {
  name: "scan-qrcode",
  mixins: [Plugins, Helpers],
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture
  },
  props: [],
  data() {
    return {
      camera: "rear",
      loading: false,
      noStreamApiSupport: false
    };
  },
  created() {},
  methods: {
    onCancel() {
      this.hideModal();
    },
    onScan(data) {
      console.log("onScan", data);
      this.showToast("Barcode detected");
      this.hideModal({
        code: data
      });
    },
    async onInit(promise) {
      this.loading = true;
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.showWarning("You need to grant camera access permisson");
        } else if (error.name === "NotFoundError") {
          this.showWarning("No camera on this device");
        } else if (error.name === "NotSupportedError") {
          this.showWarning("Secure context required (HTTPS, localhost)");
        } else if (error.name === "NotReadableError") {
          this.showWarning("Is the camera already in use?");
        } else if (error.name === "OverconstrainedError") {
          this.showWarning("Installed cameras are not suitable");
        } else if (error.name === "StreamApiNotSupportedError") {
          this.noStreamApiSupport = true;
          this.showWarning("Stream API is not supported in this browser");
        }
      } finally {
        this.loading = false;
      }
    },
    onError(promise) {
      promise.catch(console.error);
    },
    switchCamera() {
      if (this.camera === "rear") {
        this.camera = "front";
      } else if (this.camera === "front") {
        this.camera = "rear";
      } else {
        this.camera = "auto";
      }
    }
  }
};
</script>

<style scoped></style>
